import {
  GET_LINK_PREVIEW_RESULTS_FAILURE,
  GET_LINK_PREVIEW_RESULTS_SUCCESS,
  SET_LINK_PREVIEW_LOADING_START,
} from '../actions/LinkPreviewResultsActions';

const initialState = {};

export const getLinkPreviewResultsKey = ({ formKey, id }) => `${formKey}.${id}`;

function LinkPreviewResultsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_LINK_PREVIEW_LOADING_START: {
      const { formKey, id } = action.payload;
      const linkPreviewId = getLinkPreviewResultsKey({
        formKey,
        id,
      });
      return {
        ...state,
        [linkPreviewId]: {
          isFetching: true,
        },
      };
    }

    case GET_LINK_PREVIEW_RESULTS_SUCCESS: {
      const { formKey, id, formData, entityData } = action.payload;
      const linkPreviewId = getLinkPreviewResultsKey({
        formKey,
        id,
      });

      return {
        ...state,
        [linkPreviewId]: {
          isFetching: false,
          formData,
          entityData,
        },
      };
    }

    case GET_LINK_PREVIEW_RESULTS_FAILURE: {
      const { formKey, id, errors } = action.payload;
      const linkPreviewId = getLinkPreviewResultsKey({
        formKey,
        id,
      });

      return {
        ...state,
        [linkPreviewId]: {
          isFetching: false,
          errors,
        },
      };
    }

    default: {
      return state;
    }
  }
}

export default LinkPreviewResultsReducer;
